import { Upload } from 'antd';
import React, { ReactElement, useRef, useState } from 'react';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import { LoadingOutlined } from '@ant-design/icons';
import { AcceptedFileTypesArray, FILE_UPLOAD } from '../../../shared/constants/commonConstants';
import SendRequest from '../../../shared/services/sendRequest.service';
import { centeredNotification, error } from '../../../utils/utility';
import { ReactComponent as UploadSMIcon } from '../../../assets/images/svg/i_upload_sm.svg';

const UploadImage = ({ getFiles, imageUrl, imageTitle, disabled, className }: any): ReactElement => {
  const ref = useRef({ isFileValidated: true });
  const [data, setData] = useState({ loading: false, imgUrl: '' } as any);

  const handleChange = async (info: UploadChangeParam | any): Promise<any> => {
    if (info.file.status === 'uploading') {
      setData({ loading: true, imgUrl: URL.createObjectURL(info.file.originFileObj) });
      return;
    }
    if (ref.current.isFileValidated) {
      const response = await SendRequest.instance.upload(process.env.REACT_APP_BASE_URL + FILE_UPLOAD
        , [info.file.originFileObj]) as any;
      if (response && response.isSuccess) {
        getFiles(response.fileUploadDetails);
      } else if (!response.isSuccess) {
        centeredNotification(response.errorMessage);
      }
    }
  };

  const uploadButton = (
    <div>
      {data.loading ? <LoadingOutlined /> : <UploadSMIcon className="fill-gray" />}
      <div>{imageTitle ? imageTitle : 'Upload Hospital Logo'}</div>
    </div>
  );

  const validateBeforeUpload = (file: any): any => {
    if (file && AcceptedFileTypesArray.findIndex((x: string): boolean => x === file.type) !== -1) {
      ref.current.isFileValidated = true;
      return;
    } else {
      ref.current.isFileValidated = false;
      error('Please upload valid image, supported image types are (.png, .jpg, .jfif, .gif)');
    }
  };

  return (
    <Upload
      disabled={disabled}
      beforeUpload={validateBeforeUpload}
      name="avatar"
      listType="picture-card"
      className={className || 'avatar-uploader hosp-logo-upload'}
      showUploadList={false}
      onChange={handleChange}
    >
      {imageUrl && !data.imgUrl ? (
        <img className="hosp-logo" src={`data:image/jpeg;base64,${imageUrl}`} alt="Hospital Logo" />
      ) : (
          data?.imgUrl ? <img className="hosp-logo"
            src={data?.imgUrl} alt="avatar" /> : uploadButton
        )}
      <div className="img-upload-text">Upload image</div>
    </Upload>
  );
};

export default UploadImage;
